import { Routes } from '@angular/router';
import { StepIds } from '../models/property-step/property-step-model';
import { PropertyPhotosPageComponent } from '../pages/property-default-pages/property-photos-page/property-photos-page.component';
import { LifeStylePropertyInformationComponent } from '../pages/category-page-overrides/lifestyle/property-information-page.component';
import { ResidentialForSaleAgentPropertyDescriptionComponent } from '../pages/category-page-overrides/lifestyle/property-description-page.component';
import { PropertyAgentPromotePageComponent } from '../pages/property-default-pages/property-agent-promote-page/property-agent-promote-page.component';
import { LifeStylePropertySummaryPageComponent } from '../pages/category-page-overrides/lifestyle/property-summary-page.component';

export const lifeStyleRoutes: Routes = [
    {
        path: '',
        redirectTo: StepIds.propertyInformation,
        pathMatch: 'full'
    },
    {
        path: StepIds.propertyInformation,
        component: LifeStylePropertyInformationComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyInformation
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/lifestyle/property-information-page.module'
            ).then(
                (mod) =>
                    mod.LifeStylePropertyInformationPageModule
            )
    },
    {
        path: StepIds.propertyDescription,
        component: ResidentialForSaleAgentPropertyDescriptionComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyDescription
            }
        },
        loadChildren: () =>
        import(
          '../pages/category-page-overrides/lifestyle/property-description-page.module'
          ).then((mod) => mod.ResidentialForSaleAgentPropertyDescriptionPageModule)
    },
    {
        path: StepIds.propertyPhotos,
        component: PropertyPhotosPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyPhotos
            }
        }
    },
    {
        path: StepIds.propertyPromote,
        component: PropertyAgentPromotePageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyPromote
            }
        },
        loadChildren: () =>
            import(
                '../pages/property-default-pages/property-agent-promote-page/property-agent-promote-page.module'
            ).then(
                (mod) => mod.PropertyAgentPromotePageModule
            )
    },
    {
        path: StepIds.propertySummary,
        component: LifeStylePropertySummaryPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertySummary
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/lifestyle/property-summary-page.module'
            ).then(
                (mod) => mod.LifeStylePropertySummaryPageModule
            )
    }
];
